import { Reveal, MaskedLine } from "./Reveal";

const FOUNDERS = [
  {
    name: "Elio",
    role: "Co-Founder",
    photo: "/founders/elio.jpg",
    bio: "Dal lavoro come poliziotto a Milano a un ritorno profondo verso Gesù Cristo.",
  },
  {
    name: "Chiara",
    role: "Co-Founder",
    photo: "/founders/chiara.jpg",
    bio: "Il cuore della donna, l'identità femminile e la famiglia dentro la visione.",
  },
];

const ELIO_WORDS = ["Nel carattere", "Nelle scelte", "Nel corpo", "Nelle responsabilità", "Nella famiglia", "Nel lavoro"];
const CHIARA_SPACES = ["Spazi dedicati", "Call separate", "Percorsi specifici", "Momenti di confronto"];

export const Founders = () => (
  <section className="relative bg-charcoal px-5 py-28 sm:px-8 lg:py-40" data-testid="founders-section">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">
          <span className="h-px w-10 bg-gold/60" /> Chi siamo
        </p>
      </Reveal>
      <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl">
        <MaskedLine delay={0.1}>Siamo Fede &</MaskedLine>
        <MaskedLine delay={0.22}>
          <span className="text-gold">Fitness Italia.</span>
        </MaskedLine>
      </h2>

      <Reveal delay={0.3} className="mt-10 max-w-2xl space-y-5">
        <p className="text-base leading-relaxed text-ivory/60 sm:text-lg">
          Abbiamo creato Fede & Fitness Italia perché non volevamo costruire l'ennesima community
          cristiana online.
        </p>
        <p className="text-base leading-relaxed text-ivory/80 sm:text-lg">
          Vogliamo costruire un movimento nel quale la fede torni a essere vissuta nella quotidianità
          e nel quale le persone possano crescere spiritualmente, mentalmente, fisicamente e nelle
          relazioni, creando progressivamente anche connessioni e realtà sul territorio.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-8 sm:grid-cols-2 lg:max-w-4xl" data-testid="founders-grid">
        {FOUNDERS.map((f, i) => (
          <Reveal key={f.name} delay={0.15 * i}>
            <div className="group border border-ivory/10 bg-night p-8 transition-colors duration-500 hover:border-gold/40" data-testid={`founder-card-${f.name.toLowerCase()}`}>
              <div className="relative aspect-[4/5] overflow-hidden border border-ivory/10">
                <img
                  src={f.photo}
                  alt={`${f.name} — ${f.role} di Fede & Fitness Italia`}
                  className="h-full w-full object-cover grayscale-[35%] transition-all duration-700 group-hover:scale-[1.03] group-hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-night/70 via-transparent to-transparent" />
                <span className="absolute bottom-4 left-4 text-[9px] font-semibold uppercase tracking-[0.3em] text-ivory/70">
                  {f.role}
                </span>
              </div>
              <h3 className="mt-6 font-display text-2xl font-bold uppercase tracking-wide text-ivory">{f.name}</h3>
              <p className="mt-1 text-xs font-semibold uppercase tracking-[0.25em] text-gold">{f.role}</p>
              <p className="mt-4 text-sm leading-relaxed text-ivory/55">{f.bio}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <div className="mt-20 grid gap-14 lg:grid-cols-2 lg:gap-20" data-testid="founders-bios">
        <Reveal delay={0.1}>
          <div className="border-l-2 border-gold/50 pl-7 sm:pl-9" data-testid="founder-bio-elio">
            <p className="font-display text-xl font-bold uppercase tracking-wide text-ivory">La storia di Elio</p>
            <div className="mt-6 space-y-5 text-base leading-relaxed text-ivory/60">
              <p>
                Elio ha lavorato come poliziotto a Milano. Per anni ha cercato identità, forza,
                riconoscimento e direzione attraverso il lavoro, il corpo, i risultati e l'imprenditoria.
              </p>
              <p>
                Poi è arrivato un momento nel quale molte delle certezze costruite fino a quel punto
                hanno iniziato a non bastare più. È lì che è iniziato un ritorno profondo verso Gesù
                Cristo. Non verso una fede vissuta soltanto come tradizione. Ma verso una fede capace
                di entrare nella vita reale.
              </p>
            </div>
            <div className="mt-7 grid grid-cols-2 gap-x-6 gap-y-2.5">
              {ELIO_WORDS.map((w) => (
                <span key={w} className="font-display text-sm font-bold uppercase tracking-wide text-ivory/85">
                  {w}<span className="text-gold">.</span>
                </span>
              ))}
            </div>
            <div className="mt-7 space-y-5 text-base leading-relaxed text-ivory/60">
              <p className="font-serifq text-xl italic leading-snug text-sand">
                Non basta dire di credere. Ciò che crediamo deve iniziare a trasformare anche il modo
                in cui viviamo.
              </p>
              <p className="text-ivory/85">
                Da questa convinzione nasce la visione di Fede & Fitness Italia.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.25}>
          <div className="border-l-2 border-gold/50 pl-7 sm:pl-9" data-testid="founder-bio-chiara">
            <p className="font-display text-xl font-bold uppercase tracking-wide text-ivory">La storia di Chiara</p>
            <div className="mt-6 space-y-5 text-base leading-relaxed text-ivory/60">
              <p>
                Chiara è sua moglie e Co-Founder del progetto. Ha portato dentro Fede & Fitness Italia
                una parte fondamentale della visione: il cuore della donna, l'identità femminile, le
                ferite, le relazioni, la famiglia, la crescita spirituale.
              </p>
              <p className="font-serifq text-xl italic leading-snug text-sand">
                Una femminilità cristiana vissuta senza stereotipi e senza perdere la propria identità.
              </p>
              <p>
                Per questo Tempio Vivo non tratta uomini e donne come se vivessero esattamente le
                stesse battaglie.
              </p>
            </div>
            <div className="mt-7 flex flex-wrap gap-3">
              {CHIARA_SPACES.map((s) => (
                <span
                  key={s}
                  className="border border-gold/40 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-gold"
                >
                  {s}
                </span>
              ))}
            </div>
            <p className="mt-7 text-base leading-relaxed text-ivory/60">
              Nei quali uomini e donne possono lavorare sulle proprie responsabilità, domande e
              difficoltà.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
